<template>
    <div class="RwvContentMarkdownToggle">
      <b-button v-b-toggle="'collapse-' + index" :variant="data.variant">{{data.title}}</b-button>
      <b-collapse :id="'collapse-' + index" class="mt-2">
        <RwvContentMarkdown :markdown="data.markdown">
        </RwvContentMarkdown>
      </b-collapse>
    </div>
</template>

<script>
import RwvContentMarkdown from "@/components/Contents/Markdown/ContentMarkdown";

export default {
  name:"RwvContentMarkdownToggle",
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  components: {
    RwvContentMarkdown
  },
}
</script>
